// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  activateGA: false,
  baseUrl: 'https://partbnb-ui.reef.blackfin.tools',
  apiUrl: 'https://partbnb-api.reef.blackfin.tools/api'
};

export const PLAID = {
  ENVIRONMENT: {
    PRODUCTION: 'https://production.plaid.com',
    DEVELOPMENT: 'https://development.plaid.com',
    SANDBOX: 'https://sandbox.plaid.com'
  },
  CLIENT_ID: '5bf2857ad4530d0014d4a55b',
  PUBLIC_KEY: '94bba7c8e0e882e6a8884bf2684fd1',
  SECRET: '00b1702faba06d6e934f06d8c856a7',
  WEBHOOK: 'login-webhook'
};

export const CONVERTKIT = {
  API_KEY: 'Zdg985-HE-CRA5pOu2oxsA',
  SECRET: 'HBSC7N3lCYSvy3kWiRyC0X94i_DNqwZYfdwNZp3CUnU',
  CREATE_FROM_ID: '840114',
  SIGNUP_FORM_ID: '797086',
  PREORDER_FORM_ID: '840117'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
